var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ActionBar'),_c('DataTable',{attrs:{"icon":_vm.icon,"items":_vm.items,"headers":_vm.headers,"sortBy":_vm.sortBy,"showItem":_vm.showItem,"loading":!_vm.fullyLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }